export default __webpack_public_path__ + "static/media/tomi-odunsi.14f39470.png";